export enum TagButtonUIVariant {
	iconOnly = 'iconOnly',
	default = 'default',
}
